import { useState, useContext } from "react";
import { DocumentContext } from "../contexts/document";
import * as leadService from "../services/lead";
import mapAnswersToLead from "../services/lead/mapAnswersToLead";
import * as trackingService from "../services/tracking";
import usePersistedState from "./usePersistedState";
import { sendConfirmationEmails } from "../api/lead";
import buildLeadLink from "../utils/buildLeadLink";
import {
  mapCaseType,
  mapLetterType,
  mapLegalInsurance,
} from "../utils/translateAnswers";

const generateValues = (data, questions = []) => {
  return questions.reduce((acc, question) => {
    return [...acc, data[question.key]];
  }, []);
};

const useFormSubmission = ({
  stepKey,
  questions,
  submit,
  formReset,
  machineAnswers,
}) => {
  const { documents } = useContext(DocumentContext);
  const [, , resetPersistedState] = usePersistedState();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [caseId, setCaseId] = useState(null);

  const isInitialStep = stepKey === "VIOLATION_TYPE";
  const isPointsStep = stepKey === "POINTS_AMOUNT";
  const isContactDetails = stepKey === "CONTACT_DETAILS";
  const isInformationalStep = stepKey === "THANK_YOU";

  const handleSubmit = async (data) => {
    setIsSubmitting(true);

    const currentAnswer = isInformationalStep
      ? [true]
      : generateValues(data, questions);

    const allAnswers = {
      ...machineAnswers,
      ...data,
    };

    if (isInitialStep) {
      trackingService.trackStart();
    }

    try {
      const mappedAnswers = mapAnswersToLead(allAnswers);

      if (isContactDetails) {
        const caseId = await leadService.createCase(mappedAnswers, documents);

        setCaseId(caseId);
        
        await sendConfirmationEmails({
          firstName: mappedAnswers.firstName,
          lastName: mappedAnswers.lastName,
          email: mappedAnswers.email,
          telephone: mappedAnswers.phoneNumber,
          hasRSV: mapLegalInsurance(mappedAnswers.hasLegalInsurance),
          extraNotes: mappedAnswers.caseDescription,
          leadLink: buildLeadLink(caseId),
          violationType: mapCaseType(allAnswers.VIOLATION_TYPE),
          letterType: mapLetterType(allAnswers.RECEIVED_LETTER_TYPE),
          source: "AUTO MOTOR UND SPORT",
        });
      }

      if (isPointsStep) {
        await leadService.updateCaseById(caseId, mappedAnswers);
      }

      submit({ answer: currentAnswer });

      if (isContactDetails) {
        resetPersistedState();
      }
    } catch (error) {
      // TODO: Send answer to go to error page
      submit({ answer: currentAnswer });
    } finally {
      formReset();
      setIsSubmitting(false);
    }
  };

  return { handleSubmit, isSubmitting };
};

export default useFormSubmission;
